module.exports = {"522701001":"广惠街道","522701002":"文峰街道","522701004":"小围寨街道","522701005":"沙包堡街道","522701006":"绿茵湖街道","522701106":"墨冲镇","522701107":"平浪镇","522701110":"毛尖镇","522701111":"匀东镇","522701208":"归兰水族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522701.json
// module id = 2526
// module chunks = 0